import { MembershipRequestStatus, MembershipRequestType } from "@/constants";
import { i18n } from "@/plugins/i18n";

export const status = (status) => {
    let statusKey = Object.keys(MembershipRequestStatus).find(
        key => MembershipRequestStatus[key] === status
    )

    if (statusKey === undefined) {
        return
    }

    return i18n.t(`membership_request.statuses.${statusKey.toLowerCase()}`)
}

export const setType = (type) => {
    let typeKey = Object.keys(MembershipRequestType).find(
        key => MembershipRequestType[key] === type
    )

    if (typeKey === undefined) {
        return
    }

    return i18n.t(`membership_request.type.${typeKey.toLowerCase()}`)
}

export const statusColor = (status) => {
    let colors = {
        ACCEPTED: 'success',
        PENDING: 'warning',
        REJECTED: 'danger',
    }

    let statusKey = Object.keys(MembershipRequestStatus).find(
        key => MembershipRequestStatus[key] === status
    )

    if (statusKey === undefined) {
        return
    }

    return colors[statusKey]
}